import styled from "styled-components";

export const Container = styled.div`
  padding: ${(props) => props.theme.padding.primary} 20px;

  @media (min-width: 640px) {
    padding: ${(props) => props.theme.padding.primary} 20px;
  }
`;

export const Wrapper = styled.div`
  margin: 0 auto;
  width: 100%;
  max-width: 50rem;

  > h1 {
    text-align: center;
    margin-bottom: 4rem;
  }

  > button {
    margin: 0 auto;
  }
`;

export const FormDespachanteCliente = styled.form`
  display: grid;
  grid-template-columns: 1fr 0.1fr;
  gap: 1rem;
  margin-bottom: 3rem;
`;

export const NotFoundvalue = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;

  img {
    cursor: pointer;
  }
`;
